import React from "react"

export default function ProgressBar({ current, total }: { current: number, total: number }) {
  const percent = Math.min(100, Math.round((current / Math.max(total - 1, 1)) * 100))

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
      <div className="h-1.5 rounded-full bg-brand-100 overflow-hidden">
        <div
          className="h-full rounded-full bg-gradient-to-r from-brand-500 to-brand-600 transition-[width] duration-500 ease-out"
          style={{ width: `${percent}%` }}
        />
      </div>
      <p className="mt-2 text-right text-xs text-brand-700 font-medium">{percent}% do caminho</p>
    </div>
  )
}
